import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { t } from '../../i18n';
import { getInitialStyle, defaultContext } from './searchHistory.style';
import SearchedItem from './searchedItem.component';
import { SELECTED_SIGNAL } from '../../tornado/signals';

export default class SearchedItems extends Lightning.Component {
  static _template() {
    return _merge(
      {
        // Title: {},
        EmptyHistoryLabel: {},
        Items: {},
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._style = defaultContext;
    this._buttons = [];
    this._searchedItems = [];
    this._index = 0;
  }

  set searchedItems(searchedItems) {
    const isHistoryVisible = searchedItems && searchedItems.length > 0;
    this.patch({
      // Title: {
      //   visible: isHistoryVisible,
      //   text: {
      //     text: t('search.history'),
      //   },
      // },
      EmptyHistoryLabel: {
        visible: !isHistoryVisible,
        text: {
          text: t('search.empty'),
        },
      },
    });

    if (isHistoryVisible) {
      this._searchedItems = searchedItems;
      this.tag('Items').children = searchedItems.map(item => ({
        type: SearchedItem,
        data: item,
      }));
    }
    const items = this.tag('Items').children;
    this._buttons = items.filter(item => item);
  }

  get isVisibleHistory() {
    return this.tag('Items').children.length > 0;
  }

  _focus() {
    this._setIndex();
  }

  _getFocused() {
    return this._focused;
  }

  _setIndex(index = this._index) {
    this._index = index;
    this._focused = this._buttons[this._index];
    this._refocus();
  }

  _handleUp() {
    if (this._index > 0) {
      this._setIndex(this._index - 1);

      return true;
    }

    return false;
  }

  _handleDown() {
    if (this._index < this._buttons.length - 1) {
      this._setIndex(this._index + 1);

      return true;
    }

    return false;
  }

  _handleEnter() {
    this.signal(SELECTED_SIGNAL, this._searchedItems[this._index]);
  }
}
